// extracted by mini-css-extract-plugin
module.exports = {"card":"styles__card___3kNSd","logo":"styles__logo___249F-"};